import React, { useState } from 'react'
import SuperPrecoStamp from '@/modern/components/Stamps/SuperPreco'
import Icon from '@/modern/components/Icon'
import {
  SealArea,
  StampText,
  Tooltip,
  StrongText,
  Description,
  SealHeader,
} from '../style'

const SuperPreco = () => {
  const [hover, setHover] = useState(false)
  const dataTestLabel = 'tooltip_superpreco'
  return (
    <SealArea
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      hover={hover}
    >
      <SealHeader data-test-component={dataTestLabel}>
        <SuperPrecoStamp needTooltip={false} daInfo />
        <StampText>Super Preço</StampText>
        <Icon name="Arrow_6" fill="#2E2D37" size="25" />
      </SealHeader>
      <Tooltip hover={hover}>
        <Description>
          Anúncio com preço <StrongText>abaixo da tabela FIPE.</StrongText>
          <br />
          Aproveite e faça um ótimo negócio!
        </Description>
      </Tooltip>
    </SealArea>
  )
}

export default SuperPreco
